<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10"
      cy="6.3335"
      r="4"
      stroke="currentColor"
      :stroke-width="bigger ? '0.7' : '1.5'"
    />
    <path
      d="M2 18.4627C2.94796 14.9324 6.17047 12.3335 10 12.3335C13.8295 12.3335 17.052 14.9324 18 18.4627"
      stroke="currentColor"
      :stroke-width="bigger ? '0.7' : '1.5'"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconUser',
  props: {
    bigger: {
      type: Boolean,
      default: false
    }
  }
}
</script>
